module.exports = __webpack_public_path__ + "static/TiemposText-Semibold-6ae14e8ede69faa626d8508569a24d70.woff";